import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function GuaranteeSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-14 md:py-24 px-6 relative" style={{
    background: '#111827'
  }} data-id="element-120">
      <div className="max-w-3xl mx-auto text-center" data-id="element-121">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-122">
          <div className="amber-divider mb-8 md:mb-12" data-id="element-123" />

          <h2 className="text-2xl md:text-4xl font-bold mb-8 md:mb-12" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-124">
            La Garantie
          </h2>

          <div className="p-6 md:p-10 rounded-3xl relative overflow-hidden" style={{
          background: '#162030',
          border: '2px solid rgba(212,168,83,0.3)'
        }} data-id="element-125">
            <div className="text-4xl md:text-5xl mb-4 md:mb-6" data-id="element-126">🛡️</div>

            <div className="space-y-4 md:space-y-6 text-base md:text-lg leading-relaxed" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#C8C0B0'
          }} data-id="element-127">
              <p data-id="element-128">Prends le guide.</p>
              <p data-id="element-129">Applique les 10 minutes ce soir.</p>
              <p data-id="element-130">Donne-lui 30 jours.</p>

              <p className="font-bold text-lg md:text-xl my-4 md:my-8" style={{
              color: '#F5F0E8'
            }} data-id="element-131">
                Si tu ne sens pas la différence...
              </p>

              <p className="italic" style={{
              color: '#D4A853'
            }} data-id="element-132">
                Dans ton stress du dimanche. Dans tes matins. Dans ton sommeil.
                Dans ta patience.
              </p>

              <p className="font-bold text-lg md:text-xl my-4 md:my-8" style={{
              color: '#F5F0E8'
            }} data-id="element-133">
                Écris-moi. Je te rembourse les 9,97 $.
              </p>

              <p data-id="element-134">Sans question. Sans formulaire. Un email suffit.</p>

              <p className="mt-8 font-medium" data-id="element-135">
                Je te fais confiance. J'espère que tu me feras confiance aussi.
              </p>
            </div>

            <div className="mt-6 md:mt-10 pt-6 md:pt-8 border-t border-amber-500/20 text-xs md:text-sm font-bold uppercase tracking-wider" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#D4A853'
          }} data-id="element-136">
              Garantie 30 jours · Remboursement complet · Sans condition
            </div>
          </div>
        </div>
      </div>
    </section>;
}